<template>
  <div class="i-ellipsis-text">
    <i-tooltip v-if="cleanedText.length > charactersLength" :text="cleanedText">
      <template v-slot:tooltip-wrapper>
        <div class="preserve-spaces"><span v-if="showSlash">/ </span>
          {{ ellipsisText }}
        </div>
      </template>
    </i-tooltip>

    <div v-else>
      <div class="preserve-spaces"><span v-if="showSlash">/</span> {{ cleanedText }}</div>
    </div>
  </div>
</template>

<script>
import ITooltip from "@/components/common/ITooltip.vue"
import {getEllipsisStr} from "@/services/tableDataFormater";

export default {
  name: "IEllipsisText",
  components: {ITooltip},
  props: {
    text: {
      type: String,
      required: true,
    },
    charactersLength: {
      type: Number,
    },
    characters: {
      type: Number,
      default: 6
    },
    showSlash: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    cleanedText() {
      return String(this.text ?? '').replace(/\n/g, ' ').trim();
    },
    ellipsisText() {
      return getEllipsisStr(this.cleanedText, this.characters, this.charactersLength);
    }
  }
}
</script>

<style lang="scss">
@import "IEllipsisText";
</style>
